/**
 * RTWO Cryptography & Identity Engine — Base Service
 */

import { CRYPTOGRAPHY_ENGINE_VERSION } from '../domain-models';
import type {
  CryptoServiceDescriptor,
  CryptoServiceStatus,
  ICryptoService,
} from '../service-interfaces';
import type { cryptoEventBus } from '../events/crypto-event-bus';

export interface CryptoServiceContext {
  eventBus: typeof cryptoEventBus;
}

export abstract class BaseCryptoService implements ICryptoService {
  abstract readonly serviceId: string;
  abstract readonly serviceName: string;
  abstract readonly description: string;
  abstract readonly layer: 'R3' | 'R6' | 'R7';
  abstract readonly integrations: string[];
  abstract readonly requiresKeyProvider: boolean;
  abstract readonly requiresIdentityBackend: boolean;
  readonly version = CRYPTOGRAPHY_ENGINE_VERSION.version;

  protected status: CryptoServiceStatus = 'not_initialized';

  constructor(protected readonly context: CryptoServiceContext) {}

  async initialize(): Promise<void> {
    this.status = 'waiting_for_provider';
  }

  getStatus(): CryptoServiceStatus {
    return this.status;
  }

  getDescriptor(): CryptoServiceDescriptor {
    return {
      serviceId: this.serviceId,
      serviceName: this.serviceName,
      version: this.version,
      status: this.status,
      layer: this.layer,
      dependencies: [],
      description: this.description,
      integrations: this.integrations,
      requiresKeyProvider: this.requiresKeyProvider,
      requiresIdentityBackend: this.requiresIdentityBackend,
    };
  }
}
